import i18n from '@/helpers/i18n';

export default [
  {
    _name: 'CSidebarNav',
    _children: [ 
      {
        _name: 'CSidebarNavTitle',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('orders'),
        to: `/${i18n.locale}/encomendas/lista`,
        icon: 'cil-money',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('products'),
        to: `/${i18n.locale}/produtos/lista`,
        icon: 'cibCodesandbox',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('palettes'),
        to: `/${i18n.locale}/paletas/lista`,
        icon: 'cilColorPalette',
      },
      // {
      //   _name: 'CSidebarNavItem',
      //   name: i18n.t('posts'),
      //   to: `/${i18n.locale}/publicacoes/lista`,
      //   icon: 'cil-newspaper',
      // },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('categories'),
        to: `/${i18n.locale}/categorias/lista`,
        icon: 'cilTags',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('staticInfos'),
        to: `/${i18n.locale}/infos/lista`,
        icon: 'cil-info',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('users'),
        to: `/${i18n.locale}/utilizadores/lista`,
        icon: 'cil-people',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('keyValues'),
        to: `/${i18n.locale}/valores-chave/lista`,
        icon: 'cilLockLocked',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('banners'),
        to: `/${i18n.locale}/banners/lista`,
        icon: 'cil-image1',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('logout'),
        to: '/logout',
        icon: 'cil-power-standby'
      },
      {
        _name: 'CSidebarNavTitle',
      }
    ]
  }
]